import {useChangeStore} from '../../change';
import {GridEditor} from '../../../types';
import {
	breakItUp,
	getColumnsFromGrid,
	getColumnsByName,
	getDataFromGrid,
} from '../../../utils';

import {FormValues} from '@netx/core-components/Form';

export default async function all(
	gridEditor: GridEditor,
	changeStore: ReturnType<typeof useChangeStore>,
	initialValues: FormValues[],
	setProgress?: (progress: number) => void,
) {
	if (process.env.NODE_ENV === 'development') {
		console.time('reset-values/all');
	}

	const {round} = Math;

	const changes = changeStore.state.changes;
	const data = getDataFromGrid(gridEditor);
	const columns = getColumnsFromGrid(gridEditor);
	const columnsByNames = getColumnsByName(columns);

	const keys = Object.keys(changes) as string[];
	const size = keys.length;

	const amount = size <= 10 ? 1 : 10;

	await breakItUp(
		{
			amount,
			size,
		},
		(index) => {
			setProgress && setProgress(round(((index + 1) / size) * 100));

			const assetId = parseInt(keys[index] as any);

			const rowData = data.find((d) => d.assetId === assetId);
			if (!rowData) return;

			const originalRowData = initialValues.find((d) => d.assetId === assetId);
			if (!originalRowData) return;

			changes[assetId].forEach((field) => {
				const column = columnsByNames[field];
				if (!column) return;
				rowData[field] = column.properties.parseInValue
					? column.properties.parseInValue(originalRowData[field])
					: originalRowData[field];
			});
		},
	);
	changeStore.reset();
	gridEditor.repaint();

	setProgress && setProgress(100);

	if (process.env.NODE_ENV === 'development') {
		console.timeEnd('reset-values/all');
	}
}
